import { HexColor } from '@repo/shared/types';
import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';
import { link, SanityLink } from './link';

export const SanityLinkCard = z.object({
  _key: z.string(),
  link: SanityLink,
  caption: z.string().optional().nullable(),
  icon: SanityImage.optional().nullable(),
  hoverColor: HexColor.optional().nullable(),
  integrationFeatureMatch: z.array(z.string()).optional().nullable(),
});
export type SanityLinkCard = z.infer<typeof SanityLinkCard>;

export const linkCardFields = groq`{
      _key,
      caption,
      icon ${image},
      // Prefer array-shaped links (schema); fall back when content is a bare object.
      'link': coalesce(link[0], link) ${link},
      'hoverColor': hoverColor->color.hex,
      integrationFeatureMatch
    }`;
